import type { schemaType as StrapiEscapadasDetailSchemaType } from '~~/modules/api/strapi/escapadas/detail/schema'
import type { schemaType as StrapiCottagesPagechemaType } from '~~/modules/api/strapi/cottages-page/schema'
import type {
  propsInterface,
  itemInterface,
} from '~~/modules/design-system/sections/s-cards-tiny-images/s-cards-tiny-images-wrapper.vue'

export const useToSCardsTinyImagesWrapper = () => {
  const fromStrapiEscapadasDetail = (
    data: StrapiEscapadasDetailSchemaType,
  ): propsInterface => {
    let items: propsInterface['items'] = []

    if (data.attributes.featured_searches?.length) {
      items = data.attributes.featured_searches.map(item => {
        const cards: itemInterface['cards'] = item.card.map(aCard => {
          return {
            url: aCard.url,
            image: aCard.image.data[0].attributes.url,
            title: aCard.title,
          }
        })

        const returnObject: itemInterface = {
          cards,
          title: item.title || undefined,
        }
        return returnObject
      })
    }
    return { items }
  }

  const fromStrapiCottagesPage = (
    data: StrapiCottagesPagechemaType,
  ): propsInterface => {
    let items: propsInterface['items'] = []

    if (data.attributes.featured_searches?.length) {
      items = data.attributes.featured_searches.map(item => {
        const cards: itemInterface['cards'] = item.card.map(aCard => {
          return {
            url: aCard.url,
            image: aCard.image.data[0].attributes.url,
            title: aCard.title,
          }
        })

        const returnObject: itemInterface = {
          cards,
          title: item.title || undefined,
        }
        return returnObject
      })
    }
    return { items }
  }

  return { fromStrapiEscapadasDetail, fromStrapiCottagesPage }
}
